import { PageFrame } from '../components/PageFrame';
import { PricingCards } from '../components/PricingCards';

export function PricingPage() {
  return (
    <PageFrame>
      <section className="page-hero section-shell page-hero--compact">
        <p className="eyebrow">Pricing</p>
        <h1>Choose the space you need.</h1>
        <p>Three one-time packs for AI-assisted reflection and decision support. No automatic renewal and no subscription to cancel.</p>
      </section>
      <section className="section-shell pricing-page-grid">
        <PricingCards />
        <div className="definition-card">
          <h2>What counts as one question?</h2>
          <p>One question is one message you submit for an AI response. A follow-up is another question because it creates a new response.</p>
          <p>Questions are linked to your account. Purchase records and available questions stay visible in your workspace.</p>
        </div>
      </section>
    </PageFrame>
  );
}
